<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/jiadian_shorthight.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>平安家居/充电桩安装运维工雇主险</h2>
					<div>行业首选方案 | 中国平安产险承保 | 家电/家居/充电桩行业可保</div>
					<div style="margin: 15px 0">
						<i class="el-icon-success" style="color: #409eff; font-size: 18px"></i>
						住院误工费最长可赔付365天，包含自费药，赔付80%
						<br />
						<i class="el-icon-success" style="color: #409eff; font-size: 18px"></i>
						附加第三者责任，保障第三者人员伤亡
						<br />
						<i class="el-icon-error" style="color: red; font-size: 18px"></i>
						<span style="color: red">本方案存在禁保地区</span>
						<br />
						<i class="el-icon-error" style="color: red; font-size: 18px"></i>
						<span style="color: red">猝死事故死亡赔偿限额为50%</span>
						<br />
						<i class="el-icon-error" style="color: red; font-size: 18px"></i>
						<span style="color: red">延迟报案须扣除免赔额或无法赔付</span>
					</div>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<div>
						1、医疗费用（含自费药）：赔付比例为80%，检查费用以2000元为限。
						<br />
						2、误工费：100元/天（按住院天数计算误工时间，365天为限）
						<br />
						3、死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。对本保单项下发生的猝死事故，赔付金额以保单约定死亡限额的50%为限。
						<br />
						4、伤残：伤残等级赔偿限额比例表。
						<br />
						<div style="margin: 10px 0">
							<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
								<template slot="header"></template>
							</avue-crud>
						</div>
						5、延迟报案：被保险人须在保险事故发生后的48小时内向保险人报案。超48小时报案，视为延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。
					</div>
				</el-card>
				<!--        <el-descriptions :column="1" border title="注意事项">-->
				<!--          <el-descriptions-item label="投保年龄">-->
				<!--            投保年龄限16-65周岁-->
				<!--          </el-descriptions-item>-->
				<!--          <el-descriptions-item label="可投保职业">-->
				<!--            本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员-->
				<!--          </el-descriptions-item>-->
				<!--        </el-descriptions>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question = '', answer = ''} in dataQA" :key="question">
								<div>
									<span
										style="
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<div style="display: flex; margin-top: 12px">
									<span
										style="
											width: 20px;
											height: 28px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<div v-if="question === '中途是否可以加人？如何收费？'" style="display: inline-block">
										中途可以增加保障人员。新增人员时，根据该保单剩余的保障月数计算保费，剩余不足一个月的按一个月计算。
										<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
											<tr style="text-align: center">
												<th>剩余月数</th>
												<th v-for="item in 12">{{ item }}个月</th>
											</tr>
											<tr style="text-align: center">
												<td>支付比例</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
										</table>
										保单2021年4月30日24点到期，批增人员2020年5月15日起保按照年度保费的100%收取，若批增人员在6月1日起保按照年度保费的95%收取。
									</div>
									<span v-else style="white-space: pre-wrap">{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国平安财产保险股份有限公司（以下简称“中国平安”）承保，由中国平安委托博维保险经纪有限公司（以下简称“博维”）进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							</span>
							中国平安财产保险股份有限公司成立于1988年，总部位于深圳，经营区域覆盖全国，在国内各省市、自治区设有35家二级机构，1100多个营业网点。截止2022年第4季度，公司综合偿付能力充足率为220%，满足监管要求。公司最近一期的风险综合评级结果为BBB。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1、订立本合同时，本公司应向投保人说明本合同的内容。
								2、对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。
								3、本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。
								4、如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。
								5、如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。
								6、如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。
								7、本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">平安雇主责任保险（A款）</td>
									<td style="padding: 5px 0">C00001730912018083014861</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<h4>
								3.1 本保险为“雇主责任保险”
								<span class="red-bold">（具体承保内容以保单及保险条款为准）</span>
								，针对家电行业的特征，我们对您投保本份保险作以下重要提示：
							</h4>
							3.1.1
							投保人或被保险人为中华人民共和国境内注册的企业或个体工商户，获得当地市场监督管理局颁发的《营业执照》。
							3.1.2 保障人员必须为接受被保险人（或保单约定的共同被保险人）派工及管理的人员。
							<h4>3.2 投保人/被保险人</h4>
							家电、家居用品、充电桩售后服务网点（单位）为保险合同的投保人/被保险人，被保险人的分销商、二级网点为保险合同的共同被保险人。（本产品仅限于家电、家居用品、充电桩行业销售）
							<h4>3.3 保险期限</h4>
							自生效日起，保险期限为一年。
							<h4>3.4 特别约定</h4>
							下列特别约定/条款适用于保单的各个部分，均在每份保单当中载明。若其与保单的其他规定相冲突，则以下列特别约定/条款为准。
							3.4.1本保单被保险人雇员为从事家电、家居、充电桩的安装、维护、修理等工作相关人员，投保年龄限16-60周岁（不超60），与被保险人签订有劳动合同或存在事实劳动合同关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和学徒工等相关工作人员。本保单采用记名承保，在保员工以投保人提供的人员名单及其身份证号码为准。
							3.4.2在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电、家居用品、充电桩品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.3本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、第三者责任、法律费用，每项保障项目的赔偿限额应在保单明确载明。
							3.4.4本保单的共同被保险人包括但不限于保单约定的被保险人及其分销商、二级网点。但是其分销商、二级网点在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料。
							3.4.5鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。被保险人申请退保或在保人员批减时，可退保费为0。
							3.4.6被保险人须按雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保人员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.4.7本保险方案仅适用于非高空作业人员，被保险人的在保人员从事高空作业时发生的损失事故，保险人将不承担保险赔偿责任。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
							3.4.8在保险期间内，发生保险责任范围内的意外事故，保险人根据被保险人投保的人员名册，对发生死亡、伤残的人员按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。对本保单项下发生的猝死事故，赔付金额以保单约定死亡限额的50%为限。猝死的定义如下：在工作时间和工作岗位上，突发疾病死亡或在48小时之内经抢救无效死亡。
							伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿限额为死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。
							<h3 style="display: flex; justify-content: center; font-weight: bold">伤残等级赔偿限额比例表</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">伤残等级</th>
									<th style="width: 50%; padding: 5px 0">比例</th>
								</tr>
								<tr style="text-align: center">
									<td>一级</td>
									<td>100%</td>
								</tr>
								<tr style="text-align: center">
									<td>二级</td>
									<td>80%</td>
								</tr>
								<tr style="text-align: center">
									<td>三级</td>
									<td>70%</td>
								</tr>
								<tr style="text-align: center">
									<td>四级</td>
									<td>60%</td>
								</tr>
								<tr style="text-align: center">
									<td>五级</td>
									<td>50%</td>
								</tr>
								<tr style="text-align: center">
									<td>六级</td>
									<td>40%</td>
								</tr>
								<tr style="text-align: center">
									<td>六级</td>
									<td>40%</td>
								</tr>
								<tr style="text-align: center">
									<td>七级</td>
									<td>30%</td>
								</tr>
								<tr style="text-align: center">
									<td>八级</td>
									<td>20%</td>
								</tr>
								<tr style="text-align: center">
									<td>九级</td>
									<td>10%</td>
								</tr>
								<tr style="text-align: center">
									<td>十级</td>
									<td>5%</td>
								</tr>
							</table>
							伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.4.9医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.4.10医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用（其中检查费以累计2000元为限），但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按80%比例给付医疗保险金。如果被保险人已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							3.4.11自费药赔付特别约定：兹经双方同意并约定，在其它规定以保单、批单及保险条款为准的同时，被保险人的在保人员因本保险合同列明的原因所致受伤、残、死亡时，本保单扩展承保医疗费用项下必要的、合理的自费药品部分，但是，每人年累计赔偿限额在保单约定的每人医疗费用责任限额内计算。
							自费药品定义为：除社保甲、乙类用药以外的必须药品，包括乙类药品的自付部分，不包括各种营养类、滋补类药品、保健品、中药和中药饮片，也不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。
							3.4.12误工费赔付特别约定：暂时丧失工作能力且需住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的证明，保险人按照人民币100元/人/天的标准乘以住院天数（以最长365天为限）计算误工费。但是，一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据(8)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险人员的工资证明。出险人员仅需门诊治疗的，按本保单约定无误工费赔付。
							3.4.13扩展工伤事故：被保险人的在保人员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.4.14扩展承保第三者责任：本保单扩展承保在保险期间内，被保险人的在保人员在从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）时，因意外或疏忽，造成第三者的人身伤亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照本条特别约定，在保险合同载明的本项扩展责任限额内负责赔偿。
							本项扩展责任下，第三者是指除被保险人及其关联单位和关联人员以外的被保险人的工作服务对象，或与被保险人及其投保人员毫无关联关系和亲属、朋友关系的陌生人。
							本项扩展责任下，保单累计赔偿限额RMB100万元，每次事故赔偿限额RMB50万元。同一网点投保多份保单，本项扩展责任的累计赔偿限额和每次事故赔偿限额均以单份保单限额为限，赔偿限额不可叠加。
							以下情况不属于第三者责任的保障范围：
							（1）因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡；
							（2）装卸、运输货物期间发生意外事故导致的第三者人身伤亡；
							（3）第三者要求被保险人赔偿的间接损失，例如误工费、住宿费等。 （4）第三者的各类财物损坏和财务损失。
							（5）第三者实际从事或协助从事被保险人的工作过程中发生意外事故导致的人身伤亡。
							3.4.15扩展法律费用条款:在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.4.16本保单不承保高空作业人员。
							3.4.17本保单不承保投保人、被保险人及雇员工作地点属于下述地区的企业：北京市平谷区/密云区/怀柔区、河北省三河市/青龙县/廊坊市、天津市滨海区/静海区、辽宁省铁岭市、山东省禹城/莱州市/滨州市/德州市/临沂市，河南省信阳市/焦作市/新乡市/郏县、四川省宜宾市/雅安市、吉林省四平市、福建省南平下辖、江苏省常州市/连云港市、湖北省黄冈市。
							3.4.18被保险人须在保险事故发生后的48小时内向保险人报案，报案电话95511。超48小时报案，视为延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。
							以上各条特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。
							<h4>3.5 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.6 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件，并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。
							5.2您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95511。
							5.3若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或中国平安客户服务及投诉热线：95511，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {
	optionBenefit,
	optionPremium,
	optionShortPeriodRate,
	optionTaiKangDT,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product31Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionTaiKangDT,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '80万',
					plan2: '100万',
					plan3: '120万',
				},
				{
					insuredItem: '医疗费用',
					plan1: '10万',
					plan2: '15万',
					plan3: '15万',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万',
				},
				{
					insuredItem: '基础版保费',
					plan1: '568元/年',
					plan2: '658元/年',
					plan3: '738元/年',
				},
				{
					insuredItem: '第三者责任',
					plan1: `本保障项目不保障第三者的财产损失，仅承保在服务现场由于意外或疏忽所造成的第三者人身伤亡。<br/>年度累计赔偿限额100万元，每次事故（人身伤亡）赔偿限额50万元，无免赔。`,
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '10%',
					level8: '20%',
					level7: '30%',
					level6: '40%',
					level5: '50%',
					level4: '60%',
					level3: '70%',
					level2: '80%',
					level1: '100%',
				},
			],
			dataShortPeriodRate: [
				{
					month1: '30%',
					month2: '40%',
					month3: '50%',
					month4: '55%',
					month5: '60%',
					month6: '70%',
					month7: '75%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
					month12: '100%',
				},
			],
			questionDataRate: ['10%', '20%', '30%', '45%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataQA: [
				{
					question: '雇主责任险的保障范围有哪些？',
					answer:
						'在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电、家居用品、充电桩品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。',
				},
				{
					question: '有没有家电品牌、品类作业限制？',
					answer: '没有，所有家电品牌、品类作业均适用。',
				},
				{
					question: '中途是否可以加人？如何收费？',
					answer: '',
				},
				{
					question: '中途是否可以换人？',
					answer: '在保险有效期内，被替换的员工无出险的前提下，可以替换，无需缴纳保费。',
				},
				{
					question: '对投保人数有限制吗？',
					answer: '没有人数限制，1人起保。',
				},
				{
					question: '对保障人员有要求吗？',
					answer:
						'只要是单位的雇员都可以，包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。投保年龄在16-60周岁之间。',
				},
				{
					question: '保单和发票是电子版还是纸质的？',
					answer: '本方案提供有保险公司盖章的电子保单，另外根据投保单位需求可提供电子普票或纸质专票。',
				},
				{
					question: '雇主责任险是哪家保险公司承保的？',
					answer: '本雇主责任险产品是由中国平安财产保险股份有限公司承保。',
				},
				{
					question: '保单如何查验真伪？',
					answer:
						'以下两种方式均可验真，方式1：在获取电子保单后登陆中国平安保险官网http://www.pingan.com/，点击“登陆”-“保单服务”-“保单查询”选择“平安财产险保单查验”填入“保单号码”“保单验真码”“验证码”后点击提交即可查验。方式2:拨打平安保险全国客服电话95511进行人工查询。',
				},
				{
					question: '医疗费用怎么赔付？',
					answer:
						'保险人赔偿在二级或二级以上的医院发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用（其中检查费以累计2000元为限），但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按80%比例给付医疗保险金。',
				},
				{
					question: '误工费怎么赔偿？',
					answer:
						'仅门诊治疗无误工费补偿。住院治疗的事故，经保险人认可的医疗机构证明，保险公司按照人民币100元/人/天的标准计算住院期间误工费，最长不超过365天。',
				},
				{
					question: '怎样理解猝死事故的赔付金额以保单约定死亡限额的50%为限？',
					answer:
						'例如，您所投保的方案为80万方案，若发生工作时间工作岗位上的突发疾病死亡或在48小时之内经抢救无效死亡的事故，则该事故的死亡赔偿限额为40万。投保100万方案的，则该事故死亡赔偿限额为50万，如此类推。',
				},
				{
					question:
						'特别约定中有载明第三者实际从事或协助从事被保险人的工作过程中发生意外事故导致的人身伤亡，不属于保障范围，怎样理解这个除外责任？',
					answer:
						'雇员在处理安装、维修服务等售后工作时，存在工单服务人员以外的其他人（包括用户、临时工等）协助雇员完成的过程中不慎受伤的，不属于本方案的第三者责任保障范围。',
				},
				{
					question: '怎样属于延迟报案？',
					answer: '在事故发生后的48小时内，未在“美保理赔助手”微信小程序或保险公司95511热线报案成功，则属于延迟报案。',
				},
				{
					question: '事故发生后超过48小时报案，会影响案件赔付吗？',
					answer:
						'超48小时报案属于延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。因此，为避免导致影响案件理赔，请务必在出险后48小时内进行报案。',
				},
			],
		}
	},
	methods: {
		handleInsure() {
			this.$emit('insure')
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 5 || rowIndex === 8) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}
			if (rowIndex === 6) {
				if (columnIndex === 0) {
					return [1, 5]
				}
			}
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 4) {
				if (columnIndex !== 0) {
					return {
						color: 'red',
						fontWeight: 'bold',
						fontSize: '18px',
					}
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}
</style>
